/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Note_Rollback_Confirm_InInputs */

const vi_note_rollback_confirm_in = /** @type {(inputs: Note_Rollback_Confirm_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollback phiếu nhập này? Hệ thống sẽ tạo phiếu xuất điều chỉnh (đã duyệt) để trừ lại đúng số lượng đã nhập. Lô nào không còn đủ tồn thì không rollback được.`)
};

/**

* @param {Note_Rollback_Confirm_InInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const note_rollback_confirm_in = /** @type {((inputs?: Note_Rollback_Confirm_InInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Note_Rollback_Confirm_InInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_note_rollback_confirm_in(inputs)
});